import { GroupUserRole, Web3Address } from 'multirpc-sdk';
import { ChainPath } from '@ankr.com/chains-list';

import { NewProjectStep } from 'domains/projects/types';

export type Sign = -1 | 0 | 1;

// Reference: https://github.com/MetaMask/rpc-errors/blob/main/src/error-constants.ts
export enum EMetamaskErrorCode {
  // RPC error codes
  Internal = -32603,
  InvalidInput = -32000,
  InvalidParams = -32602,
  InvalidRequest = -32600,
  LimitExceeded = -32005,
  MethodNotFound = -32601,
  MethodNotSupported = -32004,
  Parse = -32700,
  ResourceNotFound = -32001,
  ResourceUnavailable = -32002,
  TransactionRejected = -32003,
  // provider error codes
  UserRejectedRequest = 4001,
  Unauthorized = 4100,
  UnsupportedMethod = 4200,
  Disconnected = 4900,
  ChainDisconnected = 4901,
}

export interface IMetamaskError {
  code: EMetamaskErrorCode;
  message: string;
  data?: unknown;
}

export type TPrimitive =
  | bigint
  | boolean
  | null
  | number
  | string
  | symbol
  | undefined;

export interface IAccount {
  address: Web3Address;
  comment?: string;
  companyType?: string;
  index: number;
  invitesCount?: number;
  isEnterprise?: boolean;
  isFreemium?: boolean;
  isSuspended?: boolean;
  membersCount?: number;
  membersLimit?: number;
  name: string;
  role: GroupUserRole;
}

export type Address = string;

interface LabelItem {
  ip: string;
  label: string;
}

interface IDraftProject {
  userEndpointToken: string;
  step: NewProjectStep;
}

/** In case of updates, please add them to wiki as well:
 * https://ankrnetwork.atlassian.net/wiki/spaces/PBRPC/pages/2797076481/Configs+AG */

// max config size is 4kb (4096 ASCII characters.)
export interface IUserProfileConfig {
  ipLabels?: LabelItem[]; // labels for whitelisted IPs for project configurations
  isFreemiumWelcomeDialogHidden?: boolean;
  isPromoBannerHidden?: boolean;
  isRPBannerHidden?: boolean;
  isWhitelistsBannerHidden?: boolean; // banner on the home page that shows the user that he has unconfigured projects whitelists
  pendingEmailForNotifications?: string;
  pendingEmailForNotificationsDatetime?: number;
  sendEmailLinkDatetime?: number;
  draftProject?: IDraftProject;
  chainsListForStatus?: ChainPath[]; // configured chains list for status page
}
